import React from 'react';
import classNames from 'classnames';
import { navigate } from 'gatsby';
import PointRight from '@/components/icons/point-right';
import PointLeft from '@/components/icons/point-left';

function Pagination({ numPages, currentPage, paginationLink }) {
	const generatePaginationItems = (currentPage, numPages) => {
		if (numPages < 7 || !numPages) {
			return [...Array(numPages).keys()].map(i => i + 1);
		}
		return [...[...Array(5).keys()].map(key => key + (currentPage - 2 > 0 ? currentPage - 2 : 1)), '...', numPages];
	};

	const paginationItems = generatePaginationItems(currentPage, numPages);
	const navigateToItem = item => {
		if (item === '...') return;
		navigate(`${paginationLink.replace(/:page/g, item === 1 ? '' : item)}`);
	};
	return (
		<div className="flex flex-row">
			<button
				type="button"
				className={classNames(
					'rounded-lg overflow-hidden border w-10 h-10 flex mx-1.5 border-grey-330 bg-white items-center justify-center',
					currentPage === 1 && 'opacity-50'
				)}
				onClick={() => currentPage > 1 && navigateToItem(currentPage - 1)}
			>
				<PointLeft />
			</button>
			{paginationItems.map(item => (
				<button
					key={item}
					type="button"
					className={classNames(
						'rounded-lg font-semibold text-l overflow-hidden border w-10 h-10 flex mx-1.5 items-center justify-center',
						item === currentPage ? ' border-mariner text-mariner bg-opacity-30 bg-mariner' : 'border-grey-330  bg-white'
					)}
					onClick={() => navigateToItem(item)}
				>
					{item}
				</button>
			))}
			<button
				type="button"
				className={classNames(
					'rounded-lg overflow-hidden border w-10 h-10 flex mx-1.5 border-grey-330 bg-white items-center justify-center',
					currentPage === numPages && 'opacity-50'
				)}
				onClick={() => numPages > currentPage && navigateToItem(currentPage + 1)}
			>
				<PointRight />
			</button>
		</div>
	);
}

export default Pagination;
